import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import * as React from "react";

const textareaVariants = cva(
  "tw-px-12 tw-py-8 focus:tw-outline focus:tw-outline-2 focus:tw-outline-blue-800 focus:tw-outline-offset-1 tw-border-gray-400 focus:tw-border-gray-900 tw-border tw-rounded-4 tw-inline-block tw-text-gray-900 placeholder:tw-text-gray-600 disabled:tw-text-gray-500 disabled:placeholder:tw-text-gray-500 tw-bg-base-white tw-min-h-[144px] tw-align-top",
  {
    variants: {
      fullWidth: {
        true: "tw-w-full",
        false: "",
      },
      error: {
        true: "tw-border-red-800 focus:tw-border-red-800",
      },
    },
  },
);

export type TextareaProps = React.ComponentProps<"textarea"> &
  Omit<VariantProps<typeof textareaVariants>, "error"> & {
    testId?: string;
    className?: string;
    fullWidth?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    errorMsg?: string;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, errorMsg, fullWidth, testId = "textarea", ...inputProps },
    ref,
  ) => {
    return (
      <textarea
        ref={ref}
        data-testid={testId}
        className={cn(
          textareaVariants({
            fullWidth: !!fullWidth,
            error: !!errorMsg,
            className,
          }),
        )}
        {...inputProps}
      />
    );
  },
);

Textarea.displayName = "Textarea";
export { Textarea };
